import React, { useState } from 'react';
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function KdStats(props) {
	let history = useHistory();
	const { state } = props.location
	const [kadStats] = useState(state[0]);
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	const stats = [];
	for (const [index, value] of kadStats.kd_stats.entries()) {
		let month = value.month;
		let splitMonth = month.split('-');
		let date = monthNames[splitMonth[1] - 1] + ' ' + splitMonth[0];
		stats.push(<div key={index} style={{marginTop:`-30px`}}>
			<div className="month">
				<hr/>
			</div>
			<div className="justify-content-center  d-flex">
				<div className="month1 align-self-center">
					<p style={{fontWeight: `normal`}}>{date}</p>
				</div>
			</div>
			<div className="row justify-content-center stat-text mt-2">
				<div className="col-11 col-md-10 col-lg-10 align-self-center d-flex">
					<div className="col-md-4" >
						<p>Change in Daily Active Users</p>
					</div>
					<div className="col-md-8">
						{ value.DAU < 0 && (
							<div className="stats-text-red float-right">
								<img src={require("./../images/stat-arrow-red.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.DAU).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
						{ value.DAU >= 0 && (
							<div className="stats-text float-right">
								<img src={require("./../images/stat-arrow.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.DAU).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="row justify-content-center stat-text mt-2">
				<div className="col-11 col-md-10 col-lg-10 align-self-center d-flex">
					<div className="col-md-4">
						<p>Change in Product per Retailer</p>
					</div>
					<div className="col-md-8">
						{ value.PPR < 0 && (
							<div className="stats-text-red float-right">
								<img src={require("./../images/stat-arrow-red.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.PPR).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
						{ value.PPR >= 0 && (
							<div className="stats-text float-right">
								<img src={require("./../images/stat-arrow.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.PPR).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="row justify-content-center stat-text mt-2">
				<div className="col-11 col-md-10 col-lg-10 align-self-center d-flex">
					<div className="col-md-4">
						<p>Change in Token per Retailer</p>
					</div>
					<div className="col-md-8">
						{ value.TPR < 0 && (
							<div className="stats-text-red float-right">
								<img src={require("./../images/stat-arrow-red.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.TPR).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
						{ value.TPR >= 0 && (
							<div className="stats-text float-right">
								<img src={require("./../images/stat-arrow.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.TPR).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="row justify-content-center stat-text mt-2">
				<div className="col-11 col-md-10 col-lg-10 align-self-center d-flex">
					<div className="col-md-4">
						<p>Attrition Rate</p>
					</div>
					<div className="col-md-8">
						{ value.UL > 0 && (
							<div className="stats-text-red float-right">
								<img src={require("./../images/stat-arrow-red.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.UL).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
						{ value.UL <= 0 && (
							<div className="stats-text float-right">
								<img src={require("./../images/stat-arrow.png").default} alt="back" className="img-fluid d-inline-block" />
								<p className=" d-inline-block">{parseFloat(value.UL).toFixed(2)}<span style={{bottom:`0em`, fontSize:`15px`}}>%</span></p>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
		);
	}
	// setStatsHtml(statsHtml);
    console.log(kadStats);

  	return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/kingdom-stats.css'}]
	}/>
	<div className="row no-gutters">
      <div className="application bg-grey">
          {/* <div style={{
				backgroundImage: `url(${kadStats.kd_image}), linear-gradient(#1A3163, #6D6264)`,
				backgroundBlendMode: `multiply`,
				backgroundSize: `cover`,
				backgroundPosition: `initial`,
				height:`84px`,
				borderBottomLeftRadius: `8px`,
				borderBottomRightRadius: `8px`,
				backgroundRepeat: `no-repeat`
			}}> */}
           	<div className="bg-gradient1">
            <div className="appHeader bg-transparent text-light position-relative">
            <div className="left">
                <a className="headerButton goBack" onClick={() => history.goBack()}>
                    <img src={require("./../images/back.png").default} alt="back"  className="img-fluid" />
                </a>
            </div>
            <div className="pageTitle">Kingdom {kadStats.kd_name}</div>
            <div className="right">
                <div className="headerButton">
					<Link to="/faq">
						<img src={require("./../images/faq.png").default} alt="back" className="img-fluid" />
					</Link>
                </div>
            </div>
            </div>
        </div>
        
        <div className="section bg-white action-sheet p-0">
          
          <div className="row stat m-auto custom-style" >
              <div className="card">
                  	<div className="card-header" style={{marginBottom:`30px`}}>
                   		<p> My Kingdom Stats</p>
                  	</div>
					<div style={{
					overflowY: 'scroll',
					overflowX: `hidden`,
					height: `calc(100vh - 200px)` ,
					width: `100%`}}>
						{stats}
					</div>

              </div>
              
          </div>
        </div>
      </div>
	  <div className="bg"></div>
    </div>
</>
  	);
}

export default KdStats;
